import { Card, Grid, Skeleton, Typography } from "@mui/material";

export default function FormLoading() {
    const formFieldList = Array(2).fill('');
    const formFields = Array(6).fill('');

    const styles = {
        avatarBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        card: {
            padding: '2rem 1.5rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start'
        },
        title: {
            fontSize: 20,
            marginBottom: '1.5rem'
        },
        gridItem: {
            width: '100%'
        }
    };

    const AvatarImageManagement = () => {
        return (
            <Grid size={{ xs: 12 }}>
                <Card sx={styles.card}>
                    <Skeleton variant="rounded" height={'7rem'} width={'100%'} />
                </Card>
            </Grid>
        );
    };

    const CustomFormBuilder = () => {
        return formFieldList?.map((_, index) => (
            <Grid key={index} size={{ xs: 12 }}>
                <Card sx={styles.card}>
                    <Typography width={'25%'} sx={styles.title} variant="h1">
                        <Skeleton />
                    </Typography>
                    <Grid container spacing={2} sx={styles.gridItem}>
                        {formFields.map((_, index) => (
                            <Grid key={index} size={{ xs: 6, md: 4 }}>
                                <Typography variant="h1">
                                    <Skeleton />
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </Card>
            </Grid>
        ));
    };

    return (
        <Grid container spacing={2}>
            <AvatarImageManagement />
            <CustomFormBuilder />
        </Grid>
    );
};